export const defaultUserGrid = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    comments: '',
    birthDate: null,
    userType: null,
    genderType: null, // true = Female, false = Male, null = Prefer not to say
    customerId: null,
}
